import { Stack } from '@mantine/core';

import { SplashLoader } from '~/domains/common/components/SplashLoader/SplashLoader';
import dt from '~/domains/contest/domains/manage/domains/common/testing.const';
import { Text } from '~/domains/design-system/Text';

export function SectionInProgressScreen() {
  return (
    <Stack
      data-test-id={dt.screen.inprogress}
      mih={500}
      h="100%"
      justify="center"
      spacing="xl"
      pt="md"
      mb="md"
    >
      <SplashLoader>
        <Text variant="label-large" ta="center">
          We are now preparing your contest for you. <br /> This will take a few seconds.
        </Text>
      </SplashLoader>
    </Stack>
  );
}
